/**
 * Format a monetary amount using the user's browser locale.
 * When a currency sign is provided it is prepended to the result.
 *
 * @example
 * formatAmount(1234.56)        // "1,234.56"  (number only)
 * formatAmount(1234.56, '$')   // "$1,234.56"
 * formatAmount(1234.56, 'MXN ') // "MXN 1,234.56"
 */
export const formatAmount = (amount: number, sign?: string): string => {
  const formatted = new Intl.NumberFormat(navigator.language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
  return sign ? `${ sign }${ formatted }` : formatted;
};
